import React from 'react';
import { useObservable } from 'react-use-observable';

import { CloseOutlined, UserOutlined } from '@ant-design/icons';
import { Modal } from 'antd';

import Spin from 'components/Spin';
import { partnerCommissionsService } from 'v2/services/reports/partnerCommissions';

import { Table } from './Table';

interface IProps {
  isOpen: boolean;
  handleClose: () => void;
}

export const DetailsModal = ({ isOpen, handleClose }: IProps) => {
  const [details] = useObservable(() => partnerCommissionsService.getPartnerCommissionsDetails(), []);
  const [loadingPartnerCommissionsDetails] = useObservable(
    () => partnerCommissionsService.getLoadingPartnerCommissionsDetails(),
    []
  );

  return (
    <Modal
      className='max-w-[670px] [&_.ant-modal-body]:max-h-[524px]'
      open={isOpen}
      onCancel={handleClose}
      width={670}
      footer={null}
      title='Mais detalhes'
      closeIcon={<CloseOutlined />}
    >
      {loadingPartnerCommissionsDetails && (
        <div className='flex items-center justify-center p-8'>
          <Spin size='large' />
        </div>
      )}
      {!loadingPartnerCommissionsDetails && (
        <div>
          <header className='flex items-center rounded-sm bg-[#ECEFF1] px-[17px] py-3'>
            <UserOutlined className='mr-2' style={{ fontSize: 24 }} />
            <span className='font-semibold'>
              Parceiro (Coprodutor): <span className='text-grey-500 font-normal'>{details?.commissioned_name}</span>
            </span>
          </header>

          <Table commissions={details?.commissions || []} />
        </div>
      )}
    </Modal>
  );
};
